/*HISTORY 1.5.0*/
if(typeof window.console==="undefined"){window.console={}}if(typeof window.console.emulated==="undefined"){if(typeof window.console.log==="function"){window.console.hasLog=true}else{if(typeof window.console.log==="undefined"){window.console.log=function(){}}window.console.hasLog=false}if(typeof window.console.debug==="function"){window.console.hasDebug=true}else{if(typeof window.console.debug==="undefined"){window.console.debug=!window.console.hasLog?function(){}:function(){var a=["console.debug:"];for(var b=0;b<arguments.length;b++){a.push(arguments[b])}window.console.log.apply(window.console,a)}}window.console.hasDebug=false}if(typeof window.console.warn==="function"){window.console.hasWarn=true}else{if(typeof window.console.warn==="undefined"){window.console.warn=!window.console.hasLog?function(){}:function(){var a=["console.warn:"];for(var b=0;b<arguments.length;b++){a.push(arguments[b])}window.console.log.apply(window.console,a)}}window.console.hasWarn=false}if(typeof window.console.error==="function"){window.console.hasError=true}else{if(typeof window.console.error==="undefined"){window.console.error=function(){var c="An error has occured.";if(window.console.hasLog){var a=["console.error:"];for(var b=0;b<arguments.length;b++){a.push(arguments[b])}window.console.log.apply(window.console,a);c="An error has occured. More information is available in your browser's javascript console."}for(var b=0;b<arguments.length;++b){if(typeof arguments[b]!=="string"){break}c+="\n"+arguments[b]}if(typeof Error!=="undefined"){throw new Error(c)}else{throw (c)}}}window.console.hasError=false}if(typeof window.console.trace==="function"){window.console.hasTrace=true}else{if(typeof window.console.trace==="undefined"){window.console.trace=function(){window.console.error("console.trace does not exist")}}window.console.hasTrace=false}window.console.emulated=true}(function(a){if(!(a.History||false)){a.History={options:{debug:false},state:"",$window:null,$iframe:null,handlers:{generic:[],specific:{}},extractHash:function(b){var c=b.replace(/^[^#]*#/,"").replace(/^#+|#+$/,"");return c},getState:function(){var b=a.History;return b.state},setState:function(c){var b=a.History;c=b.extractHash(c);b.state=c;return b.state},getHash:function(){var b=a.History;var c=b.extractHash(window.location.hash||location.hash);return c},setHash:function(c){var b=a.History;c=b.extractHash(c);if(typeof window.location.hash!=="undefined"){if(window.location.hash!==c){window.location.hash=c}}else{if(location.hash!==c){location.hash=c}}return c},go:function(e){var b=a.History;e=b.extractHash(e);var d=b.getHash(),c=b.getState();if(e!==d){b.setHash(e)}else{if(e!==c){b.setState(e)}b.trigger()}return true},hashchange:function(d){var b=a.History;var c=b.getHash();b.go(c);return true},bind:function(d,b){var c=a.History;if(b){if(typeof c.handlers.specific[d]==="undefined"){c.handlers.specific[d]=[]}c.handlers.specific[d].push(b)}else{b=d;c.handlers.generic.push(b)}return true},trigger:function(f){var d=a.History;if(typeof f==="undefined"){f=d.getState()}var b,g,c,e;if(typeof d.handlers.specific[f]!=="undefined"){e=d.handlers.specific[f];for(b=0,g=e.length;b<g;++b){c=e[b];c(f)}}e=d.handlers.generic;for(b=0,g=e.length;b<g;++b){c=e[b];c(f)}return true},construct:function(){var b=a.History;a(document).ready(function(){b.domReady()});return true},configure:function(b){var c=a.History;c.options=a.extend(c.options,b);return true},domReadied:false,domReady:function(){var b=a.History;if(b.domRedied){return}b.domRedied=true;b.$window=a(window);b.$window.bind("hashchange",this.hashchange);setTimeout(b.hashchangeLoader,200);return true},nativeSupport:function(b){return true},hashchangeLoader:function(){var c=a.History;var f=c.nativeSupport();if(!f){var b;if(a.browser.msie){c.$iframe=a('<iframe id="jquery-history-iframe" style="display: none;"></$iframe>').prependTo(document.body)[0];c.$iframe.contentWindow.document.open();c.$iframe.contentWindow.document.close();var e=false;b=function(){var i=c.getHash();var h=c.getState();var g=c.extractHash(c.$iframe.contentWindow.document.location.hash);if(h!==i){if(!e){c.$iframe.contentWindow.document.open();c.$iframe.contentWindow.document.close();c.$iframe.contentWindow.document.location.hash=i}e=false;c.$window.trigger("hashchange")}else{if(h!==g){e=true;c.setHash(g)}}}}else{b=function(){var h=c.getHash();var g=c.getState();if(g!==h){c.$window.trigger("hashchange")}}}setInterval(b,200)}else{var d=c.getHash();if(d){c.$window.trigger("hashchange")}}return true}};a.History.construct()}else{window.console.warn("$.History has already been defined...")}})(jQuery);

www.pageType='account';

function confirmLeasingCancel(orderNumber) {

	if (showLoginViewIfLogout()) {
		return;
	}

	var cancellationConfirmed = false;

	$.fancybox($('#leasingCancellationWarning').html(), {
		autoDimensions: true,
		onComplete: function () {
			$('#fancybox-content .leasing-cancellation-no').click(function (event) {
				event.preventDefault();
				$.fancybox.close();
			});
			$('#fancybox-content .leasing-cancellation-yes').click(function (event) {
				event.preventDefault();
				cancellationConfirmed = true;
				$.fancybox.close();
			});
		},
		onClosed: function () {
			if (!cancellationConfirmed) {
				return;
			}

			setTimeout(function() {
				cancelOrder('#listForm', orderNumber, false);
			}, 150);
		},
		onError: function () {
			return false;
		}
	});
}

function cancelOrder(formId, orderNumber, guestLogged) {

	if (showLoginViewIfLogout()) {
		return;
	}

	var option={
		autoDimensions:true,
		onComplete:function(){
			$('#fancybox-content input[name="reason"]').click(function(){
				otherCancelReason($(this).val());
			});
			checkbox('#fancybox-content .orderCancel .left');
			$.fancybox.resize();
		},
		onError:function(){
			return false;
		}
	};
	$.fancybox({
		href: guestLogged ? '/guest-order-cancel-reason.ltr?orderNumber='+orderNumber : '/customer-order-cancel-reason.ltr?orderNumber='+orderNumber
	}, option);
}

function otherCancelReason(value){
	if(value == $('#otherReasonId').val()){
		$('#reasonOtherMessage').show().find('input').val('');
	}else{
		$('#reasonOtherMessage').hide().find('input').val('');
	}
}

function cancelOrderOk(orderNumber, guestLogged) {

	if (showLoginViewIfLogout(true)) {
		return;
	}

	submitCancellationRequest(
		orderNumber,
		guestLogged,
		getCancellationData(),
		showCancellationSuccess,
		showCancellationError
	);
}

function getCancellationData() {
	var reasonId = $('input[name=reason]:checked').val() || '';
	var reasonOtherDetails = $('#reasonOtherMessage input').val();

	return {
		reasonId: reasonId,
		reasonOtherDetails: reasonOtherDetails
	};
}

function submitCancellationRequest(orderNumber, guestLogged, cancellationData, success, error) {

	UA.cancelOrder(orderNumber);
	UA.pageview('/akcje/konto-klienta/zamowienia/anuluj-zamowienie');
	loadingStart();

	$.ajax({
		url: guestLogged ? '/guest-order-cancel.ltr' : '/customer-order-cancel.ltr',
		type: 'POST',
		cache: false,
		data: {
			reasonId: cancellationData.reasonId,
			reasonOtherDetails: cancellationData.reasonOtherDetails,
			orderNumber: orderNumber
		},
		success: success,
		error: error
	});
}

function showCancellationSuccess(html) {
	app.alert(html, function () {
		loadingStart();
		location.reload();
	});
}

function showCancellationError() {
	loadingStop();
	$.fancybox.close();
	app.alert('Wystąpił błąd anulowania Zamówienia, prosimy spróbować później');
}

function currentAgreements(){
	$('#old-permissions input').click(function(){
		$('#old-permissions').addClass('loading');
		setTimeout(function(){
			$('#old-permissions').remove();
			$('#agreements-form').removeClass('old-mode');
		},1000);
	});
}

function orderEmailValid(){
	if (!isAnyUserLogged()) {
		loadingStart();
		location.href='/customer-current-orders.bhtml';
		return false;
	}
	if($('#F_SENDER_COMMENT').val().length>3){
		$('#trescBox').removeClass('statusError');
		$('#trescdiv').hide();
		$('#F_ACTION').val('SEND');
		$('#frontForm .buttons').text('wysyłanie...');
		$('#frontForm').ajaxSubmit({
			target: '#fancybox-content .errorForm',
			success:function(html){

			},
			error:function(){
				app.alert('Błąd wysyłania danych');
			}
		});
	}
	else{
		$('#trescdiv').show();
		$('#trescBox').addClass('statusError');
	}
}

function orderEmailBack() {
	$('#frontForm').submit();
	return false;
}

function companyName(prefix){
	function prepare(value) {
		value = '' + clean(value);
		return [value, value.substr(0, 80), value.substr(80, 80)];	// [0] wszystko, [1] pierwsza część, [2] druga część
	}
	function clean(text) {
		return text.replace(/(<([^>]+)>)/g, '').trim();
	}
	function init(prefix) {
		let $input1 = $('#' + prefix);
		if ($input1.length) {
			let $input2 = $('#' + prefix + '-cd');
			$input1.ignore(true);
			$input2.ignore(true);
			let $textarea = $('#' + prefix + '-textarea');
			let $div = $('#' + prefix + '-textarea-div');
			var $form = $input1.closest('form');
			if ($input1.hasClass('init')) {
				let text = $input1.val() + $input2.val();
				$textarea.val(text);
				$div.text(text);
			} else {
				$input1.addClass('init');
				$div.on('input', function () {
					var value = prepare($div.text());
					$textarea.val(value[0]);
					$input1.val(value[1]);
					$input2.val(value[2]);
					if ($textarea.hasClass('error') || value[0].length > 160 || value[0].length == 0) {
						$form.validate().element($textarea);
					}
				}).on('paste', function(event) {
					event.preventDefault();
					const text = (event.originalEvent || event).clipboardData.getData('text/plain');
					const normalizedText = text.replace(/\s+/g, ' ').trim();
					document.execCommand('insertText', false, normalizedText);
				});
			}
		}
	}
	init(prefix);
};


function ankietaTracker(){
	UA.pageview('/akcje/konto-klienta/zamowienia-historyczne/akcje-rekomendowane/ocen-zakupy');
}
function courierTrackingUA(view,order,status){
	UA.interaction('Konto Klienta','Zamówienia','Lokalizuj przesyłkę');
	app.logEvent({
		'id': 'parceltracker',
		'f03': order,
		'f04': status,
		'f05': view
	});
}

function loadTimeAndServices(id,url,dayIndex){
	var $deliveryDayList = $('.delivery-day-list');
	var $deliveryTimeStep1 = $deliveryDayList.closest('.delivery-time-step-1');
	var $deliverySummaryForFinancingPayment = $('#delivery-time-summary-for-financing-payment');
	$deliveryDayList.addClass('loading');
	if($deliveryTimeStep1.length) {
		$deliveryTimeStep1.addClass('delivery-day-list-loading');
	}

	$deliverySummaryForFinancingPayment.addClass('loading');

	if(!url){
		url='/customer-order-delivery-time.ltr';
	}
	$('#loadTimeAndServicesList').removeClass('error');
	$.ajax({
		url:url,
		cache : false,
		// async:false,
		data:{
			dayIndex:id
		},
		success:function(html){
			if (html.indexOf('timeDeliveryList') > -1) {
				$('#loadTimeAndServicesList').html(html);
				checkbox('#loadTimeAndServicesList');
				var selectedInterval = $('#loadTimeAndServicesList input:checked');
				if (selectedInterval.length) {
					selectedInterval.trigger('click');
				} else {
					$deliverySummaryForFinancingPayment.removeClass('active');
				}
				if($('#loadTimeAndServicesList .timeDeliveryList').hasClass('none')){
					$deliverySummaryForFinancingPayment.find('.delivery-time-summary-interval').addClass('hide');
				} else {
					$deliverySummaryForFinancingPayment.find('.delivery-time-summary-interval').removeClass('hide');
				}
				toggleDeliveryTimeStep2();
			}else{
				fancyOk('Wystąpił błąd wybierania dnia dostawy. Prosimy spróbować później lub skontaktować się z obsługą.');
			}
			$deliveryDayList.removeClass('loading');
			if($deliveryTimeStep1.length) {
				$deliveryTimeStep1.removeClass('delivery-day-list-loading');
			}
		},
		error: function () { 
			fancyOk('Wystąpił błąd wybierania dnia dostawy. Prosimy spróbować później lub skontaktować się z obsługą.');
			$deliveryDayList.removeClass('loading');
			if($deliveryTimeStep1.length) {
				$deliveryTimeStep1.removeClass('delivery-day-list-loading');
			}
		}
	});
}

function accountDeliveryTimeSummaryCalculationUpdate(json){ //desktop KME
	var $deliverySummaryForFinancingPayment = $('#delivery-time-summary-for-financing-payment');
	if(!$deliverySummaryForFinancingPayment.length) {
		return;
	}

	var $selectedDay = $('.delivery-day-list input:checked').closest('a');
	if($selectedDay.length) {
		var $deliveryName = $selectedDay.find('.deliveryName');
		$deliverySummaryForFinancingPayment.find('#delivery-time-summary-selected-type').text($deliveryName.data('delivery-kind-formatted'));
		$deliverySummaryForFinancingPayment.find('#delivery-time-price').text($deliveryName.data('formatted-price'));
	}

	var $dayIntervals = $('#loadTimeAndServicesList .timeDeliveryList');
	if ($dayIntervals.length) { // jeśli są przedziały czasowe
		var $selectedIntervalPrice = $dayIntervals.find('input:checked').closest('.newRow').find('.price');
		if($selectedIntervalPrice.length) {
			$deliverySummaryForFinancingPayment.find('#delivery-time-interval-price').text($selectedIntervalPrice.data('formatted-price'));
		}
	}

	var $deliveryTimeOwnPaymentPrice = $deliverySummaryForFinancingPayment.find('#delivery-with-own-payment-price');
	var $deliveryTimeSummaryAll = $deliverySummaryForFinancingPayment.find('#delivery-price');
	if ($deliveryTimeOwnPaymentPrice.length) {
		$deliveryTimeOwnPaymentPrice.text(json.mainOrderDeliveryWithOwnPayment);
	} else {
		$deliveryTimeSummaryAll.text(json.mainOrderDeliveryPrice != '0,00 zł' ? json.mainOrderDeliveryPrice : '0 zł');
	}
}

function accountUpdateSlectedDeliveryTimeInterval(value, guestLogged){
	$('.order_navigate').removeClass('error error1 error2');
	$('#loadTimeAndServicesList').removeClass('error');
	var $deliverySummaryForFinancingPayment = $('#delivery-time-summary-for-financing-payment');
	$deliverySummaryForFinancingPayment.addClass('loading');
	$.ajax({
		url: guestLogged ? '/guest-order-delivery-time.ltr' : '/customer-order-delivery-time.ltr',
		cache: false,
		dataType:'json',
		data: {
			'ACTION':'SELECT_INTERVAL',
			selected_interval: value
		},
		success: function(json){
			if(value==0){
				$('#delivery-time-summary-for-financing-payment').removeClass('active');
			}else{
				accountDeliveryTimeSummaryCalculationUpdate(json);
				$('#delivery-time-summary-for-financing-payment').addClass('active');
			}
			toggleDeliveryTimeStep2();
			$deliverySummaryForFinancingPayment.removeClass('loading');
		}
	});
}

function accountDeliveryTimeCalendarGrid2(url){
	if(test.getVar('delivery_payment')) {
		UA.interaction('TestAB','ab_deliverypayment',test.getVar('delivery_payment'));
	}
	$('.delivery-day-list .active a').click(function(event){
		$('.order_navigate').removeClass('error error1 error2');
		var selected=$(this).parents('.delivery-day-list').find('.selected').removeClass('selected');
		var input=$(this).addClass('selected').find('input');
		input.prop('checked',true);
		$('#deliveryKindDescriptions .deliveryKindDescription').hide();
		$('#deliveryKindDescriptions #deliveryKindDescription-'+$(this).attr('rel')).show();
		loadTimeAndServices(input.val(),url,$(this).find('input').val());
	});

	if($('.delivery-day-list .active input:checked').length){
		$('.delivery-day-list .active input:checked')[0].click();
	}
}

function toggleDeliveryTimeStep2() {
	var $step2 = $('.delivery-time-step-2');
	if ($step2.length === 0) {
		return;
	}
	if ($('.delivery-day-list input:checked').length && ($('.timeDeliveryList input:checked').length || $('.timeDeliveryList').length === 0)) {
		$step2.addClass('active');
	} else {
		$step2.removeClass('active');
	}
}

function nip(){
	$(".nip").keyfilter(/[\d\-]/).keyup(function(){
		if($(this).hasClass('individual') && $(this).val()==''){
			   $(this).parents('.statusError').addClass('statusOk').removeClass('statusError');
		}
	});
}

function eArchiveHint() {
	$('.eArchiveHelp').mouseover(function(){
		showToolBox(this,$('#eArchiveHint'+jQuery(this).attr('rel')+':eq(0)').html(),165);
	}).mouseleave(function(){
		closeToolBox();
	});
}

function gaTrackReciptFormErrors(){
	if($('#receiptForm .errorBox').hasClass('statusError')){
		UA.pageview('/akcje/konto-klienta/rejestracja-parogonow/porazka');
	}
}

function savedComparisonStart() {
	$('#menu-clipboard-sub').show().parent().addClass('has-children');
	$('#clipboard_compared').parent().addClass('active');
}

function passwordFormValidate() {

	$('#passwordForm').validate({
		rules: {
			"emailNew": {
				required: true,
				email: true
			},
			"emailNewRepeat": {
				required: true,
				email: true,
				equalTo: "#emailNew"
			}
		},
		messages: {
			"emailNew": {
				required: "Wpisz adres e-mail",
				email: "Wpisz poprawny adres e-mail"
			},
			"emailNewRepeat": {
				required: "Powtórz adres e-mail",
				email: "Powtórz poprawny adres e-mail",
				equalTo: "Podane adresy nie są identyczne"
			}
		}
	});
	if ($('#customerForm .statusError').length) $('#customer-zmien').click();
	if ($('#passwordForm .statusError').length) $('#password-zmien').click();
	if ($('#daneBox .statusError').length) $('#dane-zmien').click();

}

function redirectToNkl(applicationId) {
	if (applicationId) {
		loadingStart();
		document.location.href = '/raty/' + applicationId;
	} else {
		app.alert('Błąd wewnętrzny systemu.');
	}
}

function actionBlocked(id) {
	if(id){
		fancyOk($('.blockedMessage-'+id).html());
	}
}

function getLinks(){
	var links = "";
	$("input.zaznacz:checked").each(function (i) {
		links += '<'+'div>'+$("#mail_description_"+$(this).val()).html()+"<"+"/div>";
	});
	return links;
}
function aBoxClose(id){
	if(id=='')$('.aBox').hide();
	else $('.aBox').not('#'+id).hide('fast');

	$('.zmienB').show();
	$('.anulujB').hide();
}

function setESDPopup() {
	$('.js-esd-print').on('click', function (event) {
		$.fancybox({
			href: $(this).attr('href')
		}, {
			type: 'iframe',
			width: 980,
			height: 480
		});
		event.preventDefault();
	});

	$('.js-show-esd-code').on('click', function (event) {
		$.fancybox({
			href: '/' + 'customer-esd-codes.ltr?orderNumber=' + $(this).data('order-number') + '&orderItemId=' + $(this).data('order-item-id')+ '&orderType=' + $(this).data('order-type')
		}, {
			autoDimensions: true,
			onComplete: function onComplete(e) {
				$('#esd-modal .esd-code').on('blur', function () {
					$(this).attr('disabled', true).val($(this).data('code'));
				});
			}
		});

		event.preventDefault();
	});

	var esdClipboard = new Clipboard('.js-esd-to-clipboard');

	esdClipboard.on('success', function (e) {
		console.log($(e.trigger));
		$(e.trigger).addClass('copied');

		setTimeout(function () {
			$(e.trigger).removeClass('copied');
		}, 1500);

		e.clearSelection();
	});

	esdClipboard.on('error', function (e) {
		var inpudCodeTarget = $($(e.trigger).data('code-element'));
		inpudCodeTarget.attr('disabled', false);

		e.clearSelection();
		inpudCodeTarget.focus().select();
	});
}

function copyToClipboard(elementId) {
	$el = $('#' + elementId)[0];
	$el.select();
	try {
		document.execCommand('copy');
	} catch (err) {
		console.log('Błąd execCommand');
	}
}
